import React from "react";

const ITrash = ({
  color = "#FD4949",
  width = "14",
  height = "14",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M11.5487 2.47917L11.5203 2.94401L10.954 12.0039C10.93 12.3882 10.611 12.6875 10.226 12.6875H3.77401C3.38898 12.6875 3.07003 12.3882 3.04598 12.0039L2.47974 2.94401L2.45125 2.47917H11.5487ZM3.9113 11.8125H10.0887L10.6173 3.35417H3.38265L3.9113 11.8125Z"
        fill={color}
      />
      <path
        d="M12.25 2.47917C12.4916 2.47917 12.6875 2.67504 12.6875 2.91667C12.6875 3.15829 12.4916 3.35417 12.25 3.35417H1.75C1.50838 3.35417 1.3125 3.15829 1.3125 2.91667C1.3125 2.67504 1.50838 2.47917 1.75 2.47917H12.25Z"
        fill={color}
      />
      <path
        d="M5.6875 2.47917H8.3125V2.1875H5.6875V2.47917ZM9.1875 3.35417H4.8125V2.04167C4.8125 1.63896 5.13896 1.3125 5.54167 1.3125H8.45833C8.86104 1.3125 9.1875 1.63896 9.1875 2.04167V3.35417Z"
        fill={color}
      />
      <path
        d="M10.5171 11.9766C10.5075 12.1303 10.38 12.25 10.226 12.25H9.33333L9.62443 5.84644C9.63167 5.68558 9.50731 5.54955 9.34644 5.54224C9.18557 5.53499 9.04955 5.65936 9.04224 5.82023L8.75057 12.2369L9.04167 12.25H7.29167V5.83333C7.29167 5.67225 7.16108 5.54167 7 5.54167C6.83892 5.54167 6.70833 5.67225 6.70833 5.83333V12.25H4.95833L5.24943 12.2369L4.95776 5.82023C4.95045 5.65936 4.81442 5.535 4.65356 5.54224C4.49269 5.54955 4.36833 5.68557 4.37557 5.84644L4.66667 12.25H3.77401C3.62 12.25 3.49253 12.1303 3.48291 11.9766L2.91667 2.91667H11.0833L10.5171 11.9766Z"
        fill={color}
      />
    </svg>
  );
};

export default ITrash;
